'use client'

import { TCollectionDetail } from '@/types/collection'
import { useEffect } from 'react'

interface SeoUpdaterProps {
  collectionDetail: TCollectionDetail
}

export const SeoUpdater = ({ collectionDetail }: SeoUpdaterProps) => {
  useEffect(() => {
    if (collectionDetail?.seo_title) {
      document.title = collectionDetail.seo_title
    }

    if (collectionDetail?.seo_description) {
      const metaDescription = document.querySelector('meta[name="description"]')
      if (metaDescription) {
        metaDescription.setAttribute(
          'content',
          collectionDetail.seo_description
        )
      }
    }
  }, [collectionDetail])

  return null
}
